import api from './api';

export interface KnowledgeArticle {
  id: string;
  slug: string;
  title: string;
  category: string;
  tags: string[];
  content_md: string;
  is_published: boolean;
  created_at: string;
  updated_at: string;
}

export async function getArticleBySlug(slug: string): Promise<KnowledgeArticle> {
  const res = await api.get<KnowledgeArticle>(`/knowledge/articles/${slug}`);
  return res.data;
}

export async function listArticles(category?: string): Promise<KnowledgeArticle[]> {
  const params = category ? { category } : {};
  const res = await api.get<KnowledgeArticle[]>('/knowledge/articles', { params });
  return res.data;
}
